import { render, staticRenderFns } from "./mrc_ess_switch.vue?vue&type=template&id=072e8dc9&scoped=true&"
import script from "./mrc_ess_switch.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e8dc9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
